<template>
    <div>
        <AccumulationTable
            :hourData="hourData"
            :fiftyMinData="fiftyMinData"
            :fiveMinData="fiveMinData"
            :dailyData="dailyData"
            :monthData="monthData"
            :totalLog="totalLog"
        />
    </div>
</template>

<script>
// import moment from "moment";
import AccumulationTable from "../table/AccumulationTable.vue";
export default {
    props: {
        hourData: { type: Array, default: () => [] },
        fiftyMinData: { type: Array, default: () => [] },
        fiveMinData: { type: Array, default: () => [] },
        dailyData: { type: Array, default: () => [] },
        monthData: { type: Array, default: () => [] },
        totalLog: { type: Array, default: () => [] },
    },
    components: {
        AccumulationTable,
    },
    data() {
        return {};
    },
    watch: {},
    computed: {},
    created() {},
    mounted() {},
    methods: {},
};
</script>
